export default [
    {
        path: '/occurrence_sheet_motives',
        name: 'occurrence_sheet_motives',
        component: () => import ('./pages/Index')
    },
]